routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
    $stateProvider
        .state('page', {
            url: '/pages/:slug',
            template: require('./index.html'),
            controller: 'PagesController',
            controllerAs: 'page'
        });
}


// WEBPACK FOOTER //
// ./src/app/features/pages/routes.js